<template>
  <form @submit.prevent="onSearch" class="mt-3 mb-3">
    <div class="row ">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <SelectVue v-model="filters.lastName"
                   :options="unemployedDropdown"
                   :is-clear="true"
                   :showMinCharsMessage="true"
                   :placeholder="$t('placeholder.last_name')"
                   :no-options-text="'Type to search...'"
                   @dropdown-fetch="(search) => handleDropdownSearch(search, 'lastName')"
                   @update:modelValue="(val) => onSelectValue(val, 'lastName')"/>

<!--          <SelectVue-->
<!--              v-model="filters.unemployedId"-->
<!--              :options="unemployedDropdown"-->
<!--              :is-clear="true"-->
<!--              :placeholder="$t('placeholder.unemployed')"/>-->
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="clientDropdown && clientDropdown.length">
          <SelectVue
              v-model="filters.clientId"
              :options="clientDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.client_name')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="operationTypeDropdown && operationTypeDropdown.length">
          <SelectVue
              v-model="filters.operationType"
              :options="operationTypeDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.operation_type')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <div v-if="statusDropdown && statusDropdown.length">
          <SelectVue
              v-model="filters.status"
              :options="statusDropdown"
              :is-clear="true"
              :placeholder="$t('placeholder.status')"/>
        </div>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-12">
        <BaseInput
            v-model="filters.billNumber"
            :placeholder="$t('placeholder.bill_number')"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.startDate"
            position="down"
            :placeholder="$t('placeholder.start_date')"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <Datepicker
            v-model="filters.endDate"
            position="down"
            :placeholder="$t('placeholder.end_date')"/>
      </div>

      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>
import BaseInput from '@/components/base/BaseInput.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import { defineEmits, defineProps, toRefs, watch } from 'vue';
import SearchButton from "@/components/button/SearchButton.vue";

// Reactive filters
const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  unemployedDropdown: {
    type: Array,
    required: true,
  },
  clientDropdown: {
    type: Array,
    required: true,
  },
  operationTypeDropdown: {
    type: Array,
    required: true,
  },
  statusDropdown: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

// Use toRefs to maintain reactivity
const { filters }           = toRefs(props);
const unemployedDropdown    = toRefs(props)[ 'unemployedDropdown' ];
const clientDropdown        = toRefs(props)[ 'clientDropdown' ];
const operationTypeDropdown = toRefs(props)[ 'operationTypeDropdown' ];
const statusDropdown        = toRefs(props)[ 'statusDropdown' ];
const emit                  = defineEmits([ 'search' ]);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}

function handleDropdownSearch(search, type) {
  emit('dropdown-fetch', search, type);
}

function onSelectValue(value, type) {
  if (!value) {
    emit('clear-dropdown', type);
  }
}

</script>

<style scoped>
/* Add any custom styles for your search component */
</style>
